import PaymentTerms from '../dynamics/payment-terms'
export const getPaytmentTermById = (termId) => PaymentTerms.find(({ id }) => id === termId)